import { canonicalGenderFilterValue } from "./navigationState";

// The picker has one child group. Requests include its original baby records
// and existing source spellings, without changing stored records or exports.
const childMembers:Record<string,readonly string[]>={
  "ERKEK ÇOCUK":["ERKEK ÇOCUK","ERKEK BEBEK","BOY","BOYS","KIDS BOY","CHILD BOY","ERKEK COCUK"],
  "KIZ ÇOCUK":["KIZ ÇOCUK","KIZ BEBEK","GIRL","GIRLS","KIDS GIRL","CHILD GIRL","KIZ","KIZ COCUK"],
};

export function groupedGenderFilterOptions(values:string[]):string[]{
  return [...new Set(values.map(canonicalGenderFilterValue))];
}

export function expandGenderFilterValues(values:string[]):string[]{
  return [...new Set(values.flatMap(value=>childMembers[canonicalGenderFilterValue(value)]??[value]))];
}
